// general_controller.js
import ApplicationController from "./application_controller";
import API from '../lib/api'

// General stimulus controller added for generic events
export default class GeneralController extends ApplicationController {
  static targets = []

  connect(){
    this.dictionaryId = this.element.dataset['dictionaryId']
  }

  // For marking a column and its next column
  markColumnContinuing(e) {
    let selectedRadioButton = e.currentTarget;
    let itemId = selectedRadioButton.dataset['itemId']
    let itemType = selectedRadioButton.dataset['itemType']

    API.put({
      url: `/dictionaries/${this.dictionaryId}/continuing_columns/${itemId}`,
      data: {
        is_breaking: selectedRadioButton.value,
        item_type: itemType
      }
    }).then((response) => {
      // When columns are marked as continuous, linking columns can resequence
      // word assigned_numbers on the Highlight stage. The server includes any notification in
      // response.alert when numbers were actually changed.
      if (response.alert?.length) {
        response.alert.forEach(msg => showFlashMessage(msg, 'alert', 'float'));
      }
    });
  }
}


